module.exports = __webpack_public_path__ + "static/media/NGI.352f951b.png";